// extracted by mini-css-extract-plugin
export var aggregationCell = "_2m-o";
export var aggregationRow = "_2m-n";
export var borderlessSpinnerContainer = "_2m-3";
export var cardLayout = "_2m-6";
export var cardLayoutNoFooter = "_2m-9";
export var cardLayoutPageControl = "_2m-8";
export var closeIcon = "_2m-g";
export var columnHeaderSurface = "_2m-c";
export var columnHeaderSurfaceDragOverlay = "_2m-w";
export var columnHeaderSurfaceResizing = "_2m-t";
export var contextMenuAnchor = "_2m-1";
export var draggableColumnHeader = "_2m-u";
export var draggableColumnHeaderOverlay = "_2m-v";
export var expandIcon = "_2m-h";
export var expanded = "_2m-i";
export var filterDropdown = "_2m-j";
export var filterDropdownDivider = "_2m-e";
export var filterDropdownHeader = "_2m-m";
export var filterDropdownItem = "_2m-l";
export var filterDropdownModal = "_2m-k _2m-j";
export var filterItem = "_2m-d";
export var normalCellWithAdjustableBorder = "_2m-f";
export var pinButtonContainer = "_2m-p";
export var pinIcon = "_2m-q";
export var pinIconActive = "_2m-r";
export var spinner = "_2m-0";
export var spinnerContainer = "_2m-2";
export var tableContainer = "_2m-4";
export var tableContentDraggingColumns = "_2m-b";
export var tableContentInner = "_2m-7";
export var tableContentInnerFill = "_2m-a";
export var tableContentWrapper = "_2m-5";
export var viewButtonContainer = "_2m-s";